import React from 'react';

const MatrixFooter = ({ maxLossDays, currentWinRate, maxDailyLosses }) => {
    return (
        <div className="space-y-1.5">
            <div className="text-slate-300 text-sm">Risk Management Note</div>
            <div className="text-slate-500 text-xs mt-2 leading-relaxed">
                Given your {currentWinRate}% win rate and {maxDailyLosses} losses per day limit,
                prepare for periods of up to {maxLossDays} days where trading might
                end early. This is completely normal and is part of proper risk management.
            </div>
        </div>
    );
};

export default MatrixFooter;